module.exports = __webpack_public_path__ + "static/media/AvLogo.d8c06deb.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/general/AvLogo.png
// module id = 213
// module chunks = 0